export const calculateEecImage = ({ category = "", uniform, color = "" }) => {
    if (uniform) {
        return `pl_eek_${category.toLowerCase()}100`;
    }
    const plusCount = category.substring(1).length;
    const lowercaseCategory = category.replace(/\+/g, "").toLowerCase();

    return `pl_eek2010_${lowercaseCategory}${plusCount > 0 ? plusCount : ""}-${color.toLowerCase()}`;
};
